import type { TypeGetSelected } from '../types';

import hasClass from '../../../general/class/hasClass';

// ----------------------------------------------------------------------------

function getSelected(element: HTMLSelectElement, config: TypeGetSelected = {}): string | string[] {
    const type = config.type ?? 'value';

    if (element.multiple) {
        const list: string[] = [];

        for (const elOption of element.options) {
            if (elOption.selected || hasClass(elOption, 'selected')) {
                list.push(elOption[type]);
            }
        }

        return list;
    }

    for (const elOption of element.options) {
        if (elOption.selected || hasClass(elOption, 'selected')) {
            return elOption[type];
        }
    }

    return '';
}

// ----------------------------------------------------------------------------

export default getSelected;
